/* eslint-disable @typescript-eslint/no-explicit-any */
export default function executeWhenChangeStop(fn) {
  var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timer;
  return period ? function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      return fn.apply(void 0, args);
    }, period);
  } : fn;
}